import { LEGEARTIS_HOST_MATCHES } from '@shared/constants/constants';

export function isLegeartis(hostName: string): boolean {
  return LEGEARTIS_HOST_MATCHES.some((match) => hostName?.includes(match));
}
